
// Next example
import MoreStories from '../../components/Blog/more-stories'
import HeroPost from '../../components/Blog/hero-post'
import Intro from '../../components/Blog/intro'
import Layout from '../../components/Blog/layout'
import { getAllPostsForHome } from '../../lib/api'
import Head from 'next/head'
import { Flex } from '@chakra-ui/react'
import { FooterBanner } from '../../components/Banner/FooterBanner'
import { WrapperStyle } from '../../styles/newDesignStyles'

export default function Index({ preview, allPosts }) {

    const heroPost = allPosts[0]
    const morePosts = allPosts.slice(1);

    return (
        <Flex
            flexDir="column"
            className={"insights"}
        >

            <Layout preview={preview}>
                <Head>
                    <title>Insights - Zonado's Blog</title>
                    <meta key="description" name="description" content="Get the latest news and insights on Canadian commercial real estate and businesses by Zonado. Join our newsletter to stay up to date" />
                    <meta key="og:title" property="og:title" content={"Insights - Zonado's Blog"} />
                    <meta key="og:description" property="og:description" content={"Get the latest news and insights on Canadian commercial real estate and businesses by Zonado. Join our newsletter to stay up to date."} />
                    <link rel="canonical" href="https://zonado.com/insights" />
                </Head>
                <WrapperStyle>
                    <Intro />
                    {
                        heroPost && (
                            <HeroPost
                                title={heroPost.title}
                                coverImage={heroPost.coverImage}
                                date={heroPost.date}
                                author={heroPost.author}
                                slug={heroPost.slug}
                                excerpt={heroPost.excerpt}
                            />
                        )
                    }

                    {morePosts.length > 0 && <MoreStories posts={morePosts} />}

                    <FooterBanner />
                </WrapperStyle>
            </Layout>
        </Flex>
    )
}

Index.newLayout = true;

export async function getStaticProps({ preview = false }) {
    const allPosts = (await getAllPostsForHome(preview)) ?? []

    return {
        props: { preview, allPosts },
        revalidate: 3600
    }
}